import { FormFieldComponentProps } from "../components/new_form/form_fields/FormFieldComponent";
import { getSession } from "../helper";
import { LIST_ORGANIZATIONS } from "./routes";

export function getOrganizationForm(): FormFieldComponentProps[] {
  return [
    {
      type: "text",
      required: true,
      placeholder: "Organization Name",
      key: "name",
      label: "Name",
    },
    {
      type: "query_dropdown",
      required: false,
      key: "parentOrganizationId",
      label: "Parent Organization",
      noSelectionLabel: "No Parent Organization",
      apiCall: {
        documentNode: LIST_ORGANIZATIONS,
        key: "listOrganizations",
      },
      apiVariables: {
        session: getSession(),
      },
    },
    {
      type: "multiple_selection_query_dropdown",
      required: false,
      key: "childOrganizationIds",
      label: "Child Organizations",
      apiCall: {
        documentNode: LIST_ORGANIZATIONS,
        key: "listOrganizations",
      },
      apiVariables: {
        session: getSession(),
      },
      itemName: "Organization",
    },
  ];
}
